import ApiService from "common/service/api";
import { map, catchError } from "rxjs/operators";
import { PublicError } from 'common/service/error';


export default class TagsService extends ApiService {
  constructor(config) {
    super(config);
    this.baseURL = `${this.baseURL}/tags`;
  }

  getTagsByPageNum(pageNum, tagsData, isDelete, limit) {
    const pageLimit = limit === undefined ? 10 : limit;
    return this.fetchTagResource(`?page=${pageNum}&limit=${pageLimit}`, pageNum, tagsData === undefined? [] : tagsData, isDelete);
  }

  create(tag) {
    return this.post("", tag).pipe(
      map(ApiService.resourceJson),
      catchError((err) => {
        if (err.status === 400 && err.response) {
          throw new PublicError("failed", err.response.message, "failed");
        }
        throw err;
      })
    );
  }

  searchTagsByLabel(search, pageNum, tagsData, isDelete){
    return this.fetchTagsByLabel('/search', search, pageNum, tagsData, isDelete);
  }

  edit(id, tag){
    return this
    .patch(`/${id}`, tag)
    .pipe(
      map(ApiService.resourceJson),
      catchError((err) => {
        if (err.status === 400 && err.response) {
          throw new PublicError("failed", err.response.message, "failed");
        }
        throw err;
      }),
    );
  }

  deleteTagById(id){
    return this
    .delete(`/${id}`)
    .pipe(
      map(ApiService.resourceJson),
      catchError((err) => {
        if (err.status === 400 && err.response) {
          throw new PublicError("failed", err.response.message, "failed");
        }
        throw err;
      }),
    );
  }

  detach(detachDetails) {
    return this.post("/detach", detachDetails).pipe(
      map(ApiService.resourceJson),
      catchError((err) => {
        if (err.status === 400 && err.response) {
          throw new PublicError("failed", err.response.message, "failed");
        }
        throw err;
      })
    );
  }


  attachTag(attachTagInfo){
    return this
    .post('/attach', attachTagInfo)
    .pipe(
      map(ApiService.resourceJson),
      catchError((err) => {
        if (err.status === 400 && err.response) {
          throw new PublicError("failed", err.response.message, "failed");
        }
        throw err;
      }),
    );
  }

}
